import { combineReducers } from 'redux';

import authReducer from './authReducer';
import cookieReducer from './cookieReducer';
import uiBlockerReducer from './uiBlockerReducer';

import inFlightCasesStateReducer from '../components/ViewEntityProfile/reducers/inFlightCasesStateReducer';
import darkTitlebarReducer from '../components/layouts/reducers/darkTitleBarReducer';
import footerdetailsReducer from '../components/layouts/reducers/footerDetailsReducer';
import headerdetailsReducer from '../components/layouts/reducers/headerdetailsReducer';
import multiLangReducer from '../components/layouts/reducers/multiLangReducer';

import caseReducer from '../components/createAcase/reducers/caseReducer';
import countryInfoReducer from '../components/createAcase/reducers/countryInfoReducer';
import currencyInfoReducer from '../components/createAcase/reducers/currencyInfoReducer';
import entityReducer from '../components/createAcase/reducers/entityReducer';

import addressesReducer from '../components/CaseBody/reducers/addressesReducer';
import generateDocReducer from '../components/CaseBody/reducers/generateDocReducer';
import glsAgentReducer from '../components/CaseBody/reducers/glsAgentReducer';

import caseOwnerReducer from '../components/CaseBody/reducers/caseOwnerReducer';
import countryFormInfo from '../components/CaseBody/reducers/countryFormInfo';
import currentCustomerDetailsReducer from '../components/CaseBody/reducers/currentCustomerDetailsReducer';
import currentProductAccountReducer from '../components/CaseBody/reducers/currentProductAccountReducer';
import currentProductEchannelReducer from '../components/CaseBody/reducers/currentProductEchannelReducer';
import personsReducer from '../components/CaseBody/reducers/personsReducer';
import productDetailsReducer from '../components/CaseBody/reducers/productDetailsReducer';

import currentProductAchReducer from '../components/CaseBody/reducers/currentProductAchReducer';

import currentProductInterestEnhancement from '../components/CaseBody/ProductRequests/CaptureProductGlsInterestEnhancement/reducer/interestEnhancementReducer';
import currentProductNotionalPooling from '../components/CaseBody/ProductRequests/CaptureProductGlsNotionalPooling/reducer/currentProductNotionalPooling';
import currentActivationTabReducer from '../components/CaseBody/reducers/activationTabReducer';
import caseBodyFooterReducer from '../components/CaseBody/reducers/caseBodyFooterReducer';
import caseBodytTabsReducer from '../components/CaseBody/reducers/caseBodytTabsReducer';
import currentProductGlsCashConReducer from '../components/CaseBody/reducers/currentProductGlsCashConReducer';
import landingTabReducer from '../components/CaseBody/reducers/landingTabReducer';
import getDarkTitleBarFlag from '../components/CaseBody/reducers/setDarkBar';
import bankNameInfoReducer from '../components/createAcase/reducers/bankNameInfoReducer';
import countryInfoDataReducer from '../components/createAcase/reducers/countryInfoDataReducer';

import activeTabReducer from '../components/Admin/reducers/activeTabReducer';
import adminPanelTabReducer from '../components/Admin/reducers/adminPanelTabReducer';
import customerAdminReducer from '../components/Admin/reducers/customerAdminReducer';
import groupAdminReducer from '../components/Admin/reducers/groupAdminReducer';
import newManualCase from '../components/Admin/reducers/newManualCase';
import rafPackDetails from '../components/Admin/reducers/rafPackDetails';
import userAdminReducer from '../components/Admin/reducers/userAdminReducer';
import currentProductCashFlowForecastingReducer from '../components/CaseBody/reducers/currentProductCashFlowForecastingReducer';
import currentProductCorporateCardReducer from '../components/CaseBody/reducers/currentProductCorporateCardReducer';
import caseListFilter from '../components/CaseList/reducers/caseListFilter';
import caseMenuInfo from '../components/common/CaseMenu/reducers/caseMenuInfo';
import sowEntities from '../components/createASow/reducers/sowEntities';
import newEntities from '../components/createAcase/reducers/newEntities';
import oldEntities from '../components/createAcase/reducers/oldEntities';
import paperStatementReducer from '../components/createAcase/reducers/paperStatementReducer';
import getDarkTitleBarFlagOnPassword from '../components/layouts/reducers/getDarkTitleBarFlagOnPassword';
import customerIncorrectCredentials from '../components/layouts/reducers/incorrectCustomer';

import * as actionTypes from '../actions/actionTypes';
import sowBodyReducer from '../components/SowBody/reducers';
import configReducer from './configReducer';

const appReducer = combineReducers({
  auth: authReducer,
  uiBlocker: uiBlockerReducer,
  darkTitleBar: darkTitlebarReducer,
  cases: caseReducer,
  entities: entityReducer,
  countryInfo: countryInfoReducer,
  currencyInfo: currencyInfoReducer,
  addresses: addressesReducer,
  persons: personsReducer,
  caseOwner: caseOwnerReducer,
  currentCustomerDetails: currentCustomerDetailsReducer,
  productDetails: productDetailsReducer,
  currentProductAccount: currentProductAccountReducer,
  currentProductEchannel: currentProductEchannelReducer,
  currentProductAch: currentProductAchReducer,
  currentProductGlsCashcon: currentProductGlsCashConReducer,
  caseBodyTabsState: caseBodytTabsReducer,
  caseBodyFooterBtnsState: caseBodyFooterReducer,
  activationTabDetails: currentActivationTabReducer,
  userAdmin: userAdminReducer,
  groupAdmin: groupAdminReducer,
  customerAdmin: customerAdminReducer,
  adminPanelTabReducer: adminPanelTabReducer,
  currentProductInterestEnhancement: currentProductInterestEnhancement,
  currentProductNotionalPooling: currentProductNotionalPooling,
  inFlightCasesState: inFlightCasesStateReducer,
  newEntities: newEntities,
  oldEntities: oldEntities,
  caseListFilter: caseListFilter,
  newManualCase: newManualCase,
  rafPackDetails: rafPackDetails,
  activeTab: activeTabReducer,
  caseMenuInfo: caseMenuInfo,
  countryFormInfo: countryFormInfo,
  lang: multiLangReducer,
  bankNameInfo: bankNameInfoReducer,
  countryInfoData: countryInfoDataReducer,
  landingTabReducer: landingTabReducer,
  cookie: cookieReducer,
  headerData: headerdetailsReducer,
  footerData: footerdetailsReducer,
  generateDoc: generateDocReducer,
  glsAgent: glsAgentReducer,
  currentProductCorporateCard: currentProductCorporateCardReducer,
  customerIncorrectCredentials: customerIncorrectCredentials,
  getDarkTitleBarFlagOnPassword: getDarkTitleBarFlagOnPassword,
  getDarkTitleBarFlag,
  accountPaperStatement: paperStatementReducer,
  currentProductCashFlowForecasting: currentProductCashFlowForecastingReducer,
  sowEntities: sowEntities,
  sowBodyReducer: sowBodyReducer,
  config: configReducer
});

const rootReducer = (state, action) => {
  if (action.type === actionTypes.RESET_STORE) {
    state = { ...action.initState, auth: state.auth };
    //removing session storage data as well
    window.sessionStorage.removeItem('previousPageState');
  }
  return appReducer(state, action)
}

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/rootReducer.js